import createObserver from './createObserver'

interface IObserver {
  readonly observe: (el: Element) => IObserver
  readonly unobserve: (el: Element) => IObserver
  readonly disconnect: () => void
}

interface IProps {
  readonly threshold?: number
  readonly onHidden?: (el: Element) => void
  readonly onVisible: (el: Element) => void
}

/**
 * Láthatósági observer.
 * @param props - Props {@link IProps | A lehetséges beállítások}.
 */
export default function visibilityObserver (props: IProps): IObserver {
  const observer = createObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        props.onVisible(entry.target)
      }
      else if (props.onHidden) {
        props.onHidden(entry.target)
      }
    })
  }, { threshold: props.threshold ?? 0 }, props.onVisible)

  const ob: IObserver = {
    observe: (el: Element): IObserver => {
      observer.observe(el)

      return ob
    },
    unobserve: (el: Element): IObserver => {
      observer.unobserve(el)

      return ob
    },
    disconnect: (): void => {
      observer.disconnect()
    }
  }

  return ob
}
